const URL_API =
  window.location.host.indexOf('localhost') < 0
    ? `${window.location.protocol}//${window.location.host}`
    : ''; // for debugging

export { URL_API };
